import { BoxV2 as Box, Flex } from 'portal-commons';
import { FunctionComponent } from 'react';

interface FormTitleProps {
  title: string;
  description: string;
}

const FormTitle: FunctionComponent<FormTitleProps> = ({
  title,
  description,
}) => (
  <Flex
    sx={{
      flexDirection: 'column',
      gap: 'xs',
      width: '100%',
      pb: 'xl',
      borderBottomWidth: '1px',
      borderBottomStyle: 'solid',
      borderBottomColor: 't.black20',
      fontWeight: 400,
      lineHeight: 'normal',
    }}
  >
    <Box sx={{ fontSize: 'H600', color: 't.black90' }}>{title}</Box>
    <Box sx={{ fontSize: 'H300', color: 't.black70' }}>{description}</Box>
  </Flex>
);

export default FormTitle;
